/* eslint-disable import/prefer-default-export */
import HeaderAddressV2 from "components/organisms/HeaderAddressV2/HeaderAddressV2";

function isSchedulePortPickup(schedule: any, address_v2: any) {
  return (
    Boolean(address_v2?.pickup_is_port_address) ||
    schedule?.pickup_address_type === "airport" ||
    schedule?.pickup_address_type === "seaport"
  );
}

function isSchedulePortDelivery(schedule: any, address_v2: any) {
  return (
    Boolean(address_v2?.delivery_is_port_address) ||
    schedule?.stop1_address_type === "airport" ||
    schedule?.stop1_address_type === "seaport"
  );
}

export function renderAddressV2InfoForHeaders({ data, useRevampedDesign }: { data: any; useRevampedDesign?: boolean }) {
  const schedule = data?.schedule ?? {};
  const { address_v2 } = schedule;
  const pickup_name = address_v2?.pickup_name;
  const pickup_street = address_v2?.pickup_street_address;
  const pickup_street_line_two = address_v2?.pickup_street_address_line_two;
  const pickup_city = address_v2?.pickup_city;
  const pickup_state = address_v2?.pickup_state;
  const pickup_country = address_v2?.pickup_country;
  const pickup_zipcode = address_v2?.pickup_zipcode;

  const stop1_name = address_v2?.delivery_name;
  const stop1_street = address_v2?.delivery_street_address;
  const stop1_street_line_two = address_v2?.delivery_street_address_line_two;
  const stop1_city = address_v2?.delivery_city;
  const stop1_state = address_v2?.delivery_state;
  const stop1_country = address_v2?.delivery_country;
  const stop1_zipcode = address_v2?.delivery_zipcode;

  const renderPickupAddress = () => (
    <HeaderAddressV2
      address_name={pickup_name}
      street={pickup_street}
      street_line_two={pickup_street_line_two}
      city={pickup_city}
      state={pickup_state}
      country={pickup_country}
      zipcode={pickup_zipcode}
      useRevampedDesign={useRevampedDesign}
      portLocationOnly={isSchedulePortPickup(schedule, address_v2)}
    />
  );

  const renderDeliveryAddress = () => (
    <HeaderAddressV2
      address_name={stop1_name}
      street={stop1_street}
      street_line_two={stop1_street_line_two}
      city={stop1_city}
      state={stop1_state}
      country={stop1_country}
      zipcode={stop1_zipcode}
      useRevampedDesign={useRevampedDesign}
      portLocationOnly={isSchedulePortDelivery(schedule, address_v2)}
    />
  );

  return { renderPickupAddress, renderDeliveryAddress };
}
